import { useRequiredContext } from "@redotech/react-util/context";
import SearchIcon from "@redotech/redo-icons/search-md.svg";
import SearchFilledIcon from "@redotech/redo-icons/search-md_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { TeamType } from "@redotech/redo-model/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const SupportItem = memo(function SupportItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const hasPermission = useHasPermission(OrderManagementPermissions.VIEW_ORDER);

  const is3PL = team.teamType === TeamType.FulfillmentService;

  if (!is3PL || !hasPermission) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: `${routes.shippingBaseUrl}/support` }}
      FilledIcon={SearchFilledIcon}
      friendlyName="Support"
      id="support"
      UnfilledIcon={SearchIcon}
    />
  );
});
